import { DocService } from '@services/doc.service';
import { FileType } from '@models/file-type';
import { forkJoin, map, Observable, of, switchMap, take } from 'rxjs';
import { DocViewerStore } from '@store/legacy/doc-viewer.store';

export abstract class UploadStrategyBase {
	public title: string;
	public message: string;

	protected constructor(
		private _docService: DocService,
		private _docViewerStore: DocViewerStore
	) {
	}

	public abstract warning$(): Observable<string>;

	public abstract error$(): Observable<string>;

	public abstract tryUpload(file: File): Observable<string>;

	protected uploadInternal(file: File, fileType: FileType): Observable<string> {
		const currentDocument$ = this._docViewerStore.currentDocument$.pipe(
			take(1)
		);
		const state$ = this._docViewerStore.simpleState$.pipe(
			take(1)
		);
		return forkJoin([state$, currentDocument$]).pipe(
			switchMap(([state, document]) => {
				const ext = file.name.split('.').pop();
				if (ext.toLowerCase() !== 'pdf' && fileType !== FileType.RedactedNativeFile) {
					return of('Error: File must have PDF extension');
				} else if (ext.toLowerCase() !== 'xlsx' && fileType === FileType.RedactedNativeFile)
					return of('Error: File must have .xlsx extension');

				if (!state.hasPdfRendering) {
					return of('Error: No Normalized PDF present');
				}

				return this._docService.upload(file, fileType, document.docId).pipe(
					map((result) => result !== true ? 'Error: Uploading redacted file.' : '')
				);
			})
		);
	}
}
